import { inject } from "../../di";
import type { CreatorItem, IWritableCreatorSelectState, ICreatorSelectService } from "./types";

export class CreatorSelectService implements ICreatorSelectService {
  @inject<IWritableCreatorSelectState>("writableCreatorSelectState")
  private state!: IWritableCreatorSelectState;

  toggleSelection(item: CreatorItem): void {
    const currentIds = this.state.selectedIds.get();
    const newIds = new Set(currentIds);
    const currentItems = this.state.selectedItems.get();

    if (newIds.has(item.id)) {
      newIds.delete(item.id);
      this.state.selectedItems.set(currentItems.filter((i) => i.id !== item.id));
    } else {
      newIds.add(item.id);
      this.state.selectedItems.set([...currentItems, item]);
    }

    this.state.selectedIds.set(newIds);
  }

  setInitialSelection(items: CreatorItem[]): void {
    this.state.selectedIds.set(new Set(items.map((i) => i.id)));
    this.state.selectedItems.set([...items]);
  }

  reset(): void {
    this.state.selectedIds.set(new Set());
    this.state.selectedItems.set([]);
  }
}
